const STATIC_CERTIFICATE_URL = "https://hrl.moh.gov.et/scanned-certified-user";

export default STATIC_CERTIFICATE_URL;
